<template>
  <div class="base-status-badge">
    <!--
    <span class="base-status-badge-dot" :class="[status ? 'base-status-badge--' + status : '']"></span>
-->
    <span>{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'BaseStatusBadge',
  props: {
    text: String | Number,
    status: String // success | warning | default | error | busy | memo | idle | offline
  }
}
</script>

<style lang='scss' scoped>
@import '../../styles/variables.scss';

.base-status-badge {
  display: flex;
  align-items: center;
  font-size: 14px;
  // color: #2a2f31;
  color: #E5E8EF;

  .base-status-badge-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    //background-color: $base-default;
    background-color: white;
    margin-right: 4px;
  }

  .base-status-badge--success {
    background-color: $base-success;
  }
  .base-status-badge--warning {
    background-color: $base-warning;
  }
  .base-status-badge--default {
    background-color: $base-default;
  }
  .base-status-badge--error {
    background-color: $base-error;
  }
  .base-status-badge--busy {
    background-color: $base-busy;
  }
  .base-status-badge--memo {
    background-color: $base-memo;
  }
  .base-status-badge--idle {
    background-color: $base-idle;
  }
  .base-status-badge--offline {
    background-color: $base-offline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/BaseStatusBadge.vue